"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = _default;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

function _default() {
  return _ref.apply(this, arguments);
}

function _ref() {
  return _ref = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee(videoRef) {
    return _regenerator["default"].wrap(function (_context) {
      for (;;) {
        switch (_context.prev = _context.next) {
          case 0:
            if (void 0 !== videoRef) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            return _context.prev = 2, _context.next = 5, videoRef.play();

          case 5:
            _context.next = 12;
            break;

          case 7:
            if (_context.prev = 7, _context.t0 = _context["catch"](2), "AbortError" !== _context.t0.name) {
              _context.next = 11;
              break;
            }

            return _context.abrupt("return");

          case 11:
            throw _context.t0;

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 7]]);
  })), _ref.apply(this, arguments);
}